export default __webpack_public_path__ + "static/media/broomstick.9aee71c7.svg";